import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

import * as SchedulesActions from './schedules.actions';
import { CRMService } from '../../services/api/crm.service';

@Injectable()
export class SchedulesEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly apiService: CRMService,
    private readonly notification: NzNotificationService
  ) {}

  /* ----------------------------- Get Schedule By Id ----------------------------- */

  getSchedule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchedulesActions.getSchedule),
      switchMap(() =>
        this.apiService.getSchedule().pipe(
          map(schedule => SchedulesActions.getScheduleSuccess({ schedule })),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', `There was an error getting Schedule`);
            return of(SchedulesActions.getScheduleFailure({ error }));
          })
        )
      )
    )
  );

  /* ----------------------------- update schedule ---------------------------- */

  updateSchedule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchedulesActions.updateSchedule),
      switchMap(action =>
        this.apiService.updateSchedule(action.changes).pipe(
          tap(() => {
            this.notification.success('Success', 'Schedule updated');
          }),
          map(schedule => SchedulesActions.updateScheduleSuccess({ schedule: schedule })),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error updating the Schedule.');
            return of(SchedulesActions.updateScheduleFailure({ error }));
          })
        )
      )
    )
  );

    /* ----------------------------- update schedule ---------------------------- */

    syncSchedule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SchedulesActions.syncSchedule),
      switchMap(action =>
        this.apiService.syncSchedule(action.id).pipe(
          tap(() => {
            this.notification.success('Success', 'Schedule synced');
          }),
          map(schedule => SchedulesActions.syncScheduleSuccess({ id: action.id, schedule: schedule })),
          catchError(error => {
            console.error('Error', error);
            this.notification.error('Error', 'There was an error syncing the Schedule.');
            return of(SchedulesActions.syncScheduleFailure({ error }));
          })
        )
      )
    )
  );
}

